import { createRouter, createWebHashHistory } from "vue-router";

const routes = [
  {
    path: "/:pathMatch(.*)*",
    meta: { layout: "LayoutsMain" },
    beforeEnter: (to, from, next) => {
      next("/404");
    },
  },
  {
    path: "/404",
    name: "404",
    component: () => import("@/views/404"),
  },
  {
    path: "/",
    name: "login",
    meta: { layout: "LayoutsDefault", name: "" },
    component: () => import("../views/LoginView.vue"),
  },
  {
    path: "/login",
    name: "login",
    meta: { layout: "LayoutsDefault", name: "" },
    component: () => import("../views/LoginView.vue"),
  },
  {
    path: "/main",
    name: "main",
    meta: { layout: "LayoutsMain", name: "" },
    component: () => import("../views/MainView.vue"),
  },
  {
    path: "/change-password",
    name: "change-password",
    meta: { layout: "LayoutsMain",  name: "" },
    component: () => import("../views/profile/ChangePassword.vue"),
  },
  {
    name: "management",
    children: [
      {
        path: "/management",
        name: "management",
        meta: { layout: "LayoutsMain", name: "" },
        component: () => import("../views/MainView.vue"),
      },
      /* user route */
      {
        path: "/management/user",
        name: "user-management",
        meta: { layout: "LayoutsMain", name: "ຈັດການຜູ້ໃຊ້" },
        component: () =>
          import("../views/manageView/bussiness/bussinessView.vue"),
      },

      /* feetype route */
      {
        path: "/management/feetype",
        name: "feetype-management",
        meta: { layout: "LayoutsMain", name: "ປະເພດ" },
        component: () => import("../views/manageView/feetype/FeeTypeView.vue"),
      },
      {
        path: "/management/feetype/add",
        name: "feetype-add",
        meta: { layout: "LayoutsMain", name: "ເພີ່ມປະເພດ" },
        component: () => import("../views/manageView/feetype/FeeTypeAdd.vue"),
      },
      {
        path: "/management/feetype/edit/:fee_type_id",
        name: "feetype-edit",
        meta: { layout: "LayoutsMain", name: "ແກ້ໄຂປະເພດ" },
        component: () => import("../views/manageView/feetype/FeeTypeEdit.vue"),
      },

      /* category route */
      {
        path: "/management/sector/category/:sector_code",
        name: "category-management",
        meta: { layout: "LayoutsMain", name: "ປະເພດຫຍ້ອຍ" },
        component: () =>
          import("../views/manageView/category/CategoryView.vue"),
      },
      {
        path: "/management/sector/category/add/:sector_code",
        name: "category-add",
        meta: { layout: "LayoutsMain", name: "ເພີ່ມປະເພດຫຍ້ອຍ" },
        component: () => import("../views/manageView/category/CategoryAdd.vue"),
      },
      {
        path: "/management/sector/category/detail/:cate_id",
        name: "category-detail",
        meta: { layout: "LayoutsMain", name: "ລາຍລະອຽດປະເພດຫຍ້ອຍ" },
        component: () =>
          import("../views/manageView/category/CategoryDetail.vue"),
      },

      /* document */
      {
        path: "/management/document",
        name: "document-management",
        meta: { layout: "LayoutsMain", name: "ເອກະສານຕິດຄັດ" },
        component: () =>
          import("../views/manageView/document/DocumentView.vue"),
      },
      {
        path: "/management/document/add",
        name: "document-add",
        meta: { layout: "LayoutsMain", name: "ເພີ່ມເອກະສານຕິດຄັດ" },
        component: () => import("../views/manageView/document/DocumentAdd.vue"),
      },
      {
        path: "/management/document/edit",
        name: "document-edit",
        meta: { layout: "LayoutsMain", name: "ແກ້ໄຂເອກະສານຕິດຄັດ" },
        component: () =>
          import("../views/manageView/document/DocumentEdit.vue"),
      },
      /* employee */
      {
        path: "/management/employee",
        name: "employee-management",
        meta: { layout: "LayoutsMain", name: "ພະນັກງານ" },
        component: () =>
          import("../views/manageView/employee/employeeView.vue"),
      },
      {
        path: "/management/employee/add",
        name: "employee-add",
        meta: { layout: "LayoutsMain", name: "ເພີ່ມພະນັກງານ" },
        component: () => import("../views/manageView/employee/employeeAdd.vue"),
      },
      {
        path: "/management/employee/edit/:emp_id",
        name: "employee-edit",
        meta: { layout: "LayoutsMain", name: "ແກ້ໄຂພະນັກງານ" },
        component: () =>
          import("../views/manageView/employee/employeeEdit.vue"),
      },
      {
        path: "/management/province",
        name: "province-management",
        meta: { layout: "LayoutsMain", name: "ແຂວງ" },
        component: () =>
          import("../views/manageView/province/provinceView.vue"),
      },
      {
        path: "/management/province/edit",
        name: "province-edit",
        meta: { layout: "LayoutsMain", name: "ແກ້ໄຂແຂວງ" },
        component: () =>
          import("../views/manageView/province/provinceEdit.vue"),
      },
      {
        path: "/entreaty-edit/application/:ent_id",
        name: "application-edit",
        meta: { layout: "LayoutsMain", name: "ແກ້ໄຂໃບຄໍາຮ້ອງ" },
        component: () => import("../views/entreatyView/edit/ApplicationEdit.vue"),
      },
      {
        path: "/management/province/add",
        name: "province-add",
        meta: { layout: "LayoutsMain", name: "ເພີ່ມແຂວງ" },
        component: () =>
          import("../views/manageView/province/provinceAdd.vue"),
      },
      {
        path: "/management/department",
        name: "department-management",
        meta: { layout: "LayoutsMain", name: "ພະແນກ" },
        component: () =>
          import("../views/manageView/department/departmentView.vue"),
      },
      {
        path: "/management/department/edit",
        name: "department-edit",
        meta: { layout: "LayoutsMain", name: "ແກ້ໄຂພະແນກ" },
        component: () =>
          import("../views/manageView/department/departmentEdit.vue"),
      },
      {
        path: "/management/department/add",
        name: "department-add",
        meta: { layout: "LayoutsMain", name: "ເພີ່ມພະແນກ" },
        component: () =>
          import("../views/manageView/department/departmentAdd.vue"),
      },
      {
        path: "/management/organization",
        name: "organization-management",
        meta: { layout: "LayoutsMain", name: "ຂັ້ນຄຸ້ມຄອງ" },
        component: () =>
          import("../views/manageView/department/departmentView.vue"),
      },
      {
        path: "/management/organization/edit",
        name: "organization-edit",
        meta: { layout: "LayoutsMain", name: "ແກ້ໄຂຂັ້ນຄຸ້ມຄອງ" },
        component: () =>
          import("../views/manageView/department/departmentEdit.vue"),
      },
      {
        path: "/management/organization/add",
        name: "organization-add",
        meta: { layout: "LayoutsMain", name: "ເພີ່ມຂັ້ນຄຸ້ມຄອງ" },
        component: () =>
          import("../views/manageView/department/departmentAdd.vue"),
      },
      {
        path: "/management/emp_level",
        name: "level-management",
        meta: { layout: "LayoutsMain", name: "ປະເພດຜູ້ໃຊ້ງານ" },
        component: () =>
          import("../views/manageView/department/departmentView.vue"),
      },
      {
        path: "/management/emp_level/edit",
        name: "level-edit",
        meta: { layout: "LayoutsMain", name: "ແກ້ໄຂປະເພດຜູ້ໃຊ້ງານ" },
        component: () =>
          import("../views/manageView/department/departmentEdit.vue"),
      },
      {
        path: "/management/emp_level/add",
        name: "emp_level-add",
        meta: { layout: "LayoutsMain", name: "ເພີ່ມປະເພດຜູ້ໃຊ້ງານ" },
        component: () =>
          import("../views/manageView/department/departmentAdd.vue"),
      },
    ],
  },
  {
    name: "entreaty",
    meta: { layout: "LayoutsMain" },
    children: [
      {
        path: "/entreaty",
        name: "entreaty",
        meta: { layout: "LayoutsMain", name: "" },
        component: () => import("../views/MainView.vue"),
      },
      {
        path: "/entreaty/waiting",
        name: "all-entreaty",
        meta: { layout: "LayoutsMain", name: "ໃບຄໍາຮ້ອງລໍຖ້າການຮັບ" },
        component: () => import("../views/entreatyView/EntWaitingView.vue"),
      },
      {
        path: "/entreaty/detail/:ent_id",
        name: "detail-entreaty",
        meta: { layout: "LayoutsMain", name: "ກວດສອບໃບຄຳຮ້ອງ" },
        component: () => import("../views/entreatyView/EntDetail.vue"),
      },
      {
        path: "/entreaty/view/:ent_id",
        name: "view-entreaty",
        meta: { layout: "LayoutsMain", name: "ລາຍລະອຽດໃບຄໍາຮ້ອງ" },
        component: () => import("../views/entreatyView/EntView.vue"),
      },
      {
        path: "/entreaty/process",
        name: "process-entreaty",
        meta: { layout: "LayoutsMain", name: "ໃບຄໍາຮ້ອງທີ່ດໍາເນີນການ" },
        component: () => import("../views/entreatyView/EntProcessView.vue"),
      },
      {
        path: "/entreaty/done",
        name: "done-entreaty",
        meta: { layout: "LayoutsMain", name: "ໃບຄໍາຮ້ອງທີ່ອະນຸມັດແລ້ວ" },
        component: () => import("../views/entreatyView/EntDoneView.vue"),
      },
      {
        path: "/entreaty/paid",
        name: "paid-entreaty",
        meta: { layout: "LayoutsMain", name: "ໃບຄໍາຮ້ອງທີ່ຊໍາລະແລ້ວ" },
        component: () => import("../views/entreatyView/EntPaidView.vue"),
      },
      {
        path: "/entreaty/handover",
        name: "handover-entreaty",
        meta: { layout: "LayoutsMain", name: "ໃບຄໍາຮ້ອງທີ່ມອບແລ້ວ" },
        component: () => import("../views/entreatyView/EntHandoverView.vue"),
      },
      {
        path: "/entreaty/timeline/:ent_id",
        name: "timeline-entreaty",
        meta: { layout: "LayoutsMain", name: "ການເຄື່ອນໄຫວໃບຄຳຮ້ອງ" },
        component: () => import("../views/entreatyView/TimelineView.vue"),
      },
      {
        path: "/entreaty/payment",
        name: "payment-entreaty",
        meta: { layout: "LayoutsMain", name: "ລາຍການຊຳລະເງີນ" },
        component: () => import("../views/entreatyView/PaymentView.vue"),
      },
    ],
  },
  /* reporting */
  {
    name: "reporting",
    meta: { layout: "LayoutsMain" },
    children: [
      {
        path: "/reporting",
        name: "reporting",
        meta: { layout: "LayoutsMain", name: "" },
        component: () => import("../views/MainView.vue"),
      },
      {
        path: "/reporting/income",
        name: "reporting-income",
        meta: { layout: "LayoutsMain", name: "ລາຍງານລາຍຮັບ" },
        component: () => import("../views/reportView/reportIncomeView.vue"),
      },
      {
        path: "/reporting/approved",
        name: "reporting-approved",
        meta: { layout: "LayoutsMain", name: "ລາຍງານການອອກໃບອານຸຍາດ" },
        component: () => import("../views/reportView/reportApprovedView.vue"),
      },
      {
        path: "/reporting/companies",
        name: "reporting-companies",
        meta: { layout: "LayoutsMain", name: "ລາຍງານບໍລິສັດທີລົງທະບຽນ" },
        component: () => import("../views/reportView/reportCompaniesView.vue"),
      },
    ],
  },
];

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
    if (localStorage.getItem('access_Token') == null) {
      if(to.path == '/login' ){
        next();
      }else{
        next({
          path: '/login'
        })
      }
    } else {

        if(to.path=='/' || to.path=='/login' ){
          next({
            path: '/main'
          })
        }else{
          next();
        }
    }
})

export default router;
